export default {
    SET_ACTIVE_MENU_ITEM: 'set_active_menu_item',
};
